import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import TextField from '../components/TextField';
import { useAuth } from '../auth-context';
import { toast } from "react-toastify";
import { baserUrl } from "../typings";

function LoginPage() {
    const { setToken } = useAuth();
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const onLogin = () => {
        fetch(`${baserUrl}/auth/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ username, password })
        })
            .then(res => {
                if (res.status === 200) {
                    return res.text();
                }
                return Promise.reject();
            })
            .then(token => {
                setToken(token);
                navigate('/');
            }).catch(() => {
            toast.error('Login failed');
        });
    };

    return (
        <div className="container">

            <div className="title">SC Login</div>

            <div className="box" style={{gap: '12px'}}>

                <TextField
                    label="Username"
                    placeholder="Enter your username"
                    value={username}
                    setValue={setUsername}
                />

                <TextField
                    type="password"
                    label="Password"
                    placeholder="Enter your password"
                    value={password}
                    setValue={setPassword}
                />

                <button className="my-button" onClick={onLogin}>LOGIN</button>

            </div>

        </div>
    );
}

export default LoginPage;
